export const DEFAULT_NUMBER_OF_STARS = 5;
